export enum ProfileMenuId {
  Alarm,
  Cash,
  PassVip,
  Coupon,
  Reply,
  Voucher,
  Settings,
  Notice,
  Customer,
}

export const PROFILE_MENU_CLICK_ACTION_NAME_MAP: {
  [key in ProfileMenuId]: string;
} = {
  [ProfileMenuId.PassVip]: '캐시패스_클릭',
  [ProfileMenuId.Cash]: '캐시내역_클릭',
  [ProfileMenuId.Voucher]: '이용권내역_클릭',
  [ProfileMenuId.Reply]: '댓글내역_클릭',
  [ProfileMenuId.Coupon]: '쿠폰등록_클릭',
  [ProfileMenuId.Settings]: '설정_클릭',
  [ProfileMenuId.Customer]: '고객센터_클릭',
  [ProfileMenuId.Notice]: '공지사항_클릭',
  [ProfileMenuId.Alarm]: '알림_클릭',
};
